export const GET_ANNOUNCE_STATUS_LIST = "GET_ANNOUNCE_STATUS_LIST";

export const ANNOUNCE_LIST_ACTION = "ANNOUNCE_LIST_ACTION";
export const ANNOUNCE_WRITE_ACTION = "ANNOUNCE_WRITE_ACTION";
